export enum PartnershipPolicySegments {
    VIEW_INTERNET_POLICY_PAGE = 'view_internet_policy_page',
    TAP_BTN_CLAIM = 'tap_btn_claim',
    TAP_ONGOING_CLAIMS_CTA = 'tap_ongoing_claims_cta',
    TAP_BTN_DOWNLOAD_POLICY = 'tap_btn_download_policy',
    TAP_SHARE_POLICY_CTA = 'tap_share_policy_cta',
    TAP_ADD_DEPENDENT = 'tap_add_dependent',
    TAP_ADD_DEPENDENT_SUBMIT = 'tap_add_dependent_submit',
    TAP_ADD_NOMINEE = 'tap_add_nominee',
    TAP_ADD_NOMINEE_SUBMIT = 'tap_add_nominee_submit',
    TAP_BTN_PDP_DOWNLOAD_APP = 'tap_btn_pdp_download_app',
}

export enum ClaimTrackingSegements {
    TAP_CLAIM_WITHDRAWN = 'tap_claim_withdrawn',
    TAP_CLAIM_BREAKUP = 'tap_claim_breakup',
    TAP_UPLOAD_DOCUMENT_CTA = 'tap_upload_document_cta',
    TAP_PAYMENT_DETAILS_CTA = 'tap_payment_details_cta',
    TAP_RETRY_RAISE_REPAIR_REQUEST = 'tap_retry_raise_repair_request',
    TAP_WITHDRAW_REQUEST_INITIATE = 'tap_withdraw_request_initiate',
    TAP_WITHDRAW_REQUEST_SUBMIT = 'tap_withdraw_request_submit',
}

export enum ElectronicsPolicyDetailsViewEvents {
    VIEW_PAGE_PDP = 'view_page_pdp',
    VIEW_PAGE_REQUEST_WITHDRAW_SUCCESS_POPUP = 'view_page_request_withdrawn_success_popup',
}

export enum ElectronicsPolicyDetailsSegments {
    TAP_RAISE_REPAIR_REQUEST = 'tap_raise_repair_request',
    TAP_DOWNLOAD_POLICY_DOCUMENT = 'tap_download_policy_document',
    TAP_TRACK_REPAIR_BUBBLE = 'tap_track_repair_bubble',
    TAP_EDIT_POLICY_DETAILS_CTA = 'tap_edit_policy_details_cta',
    TAP_OVERVIEW_TAB = 'tap_overview_tab',
    TAP_FAQ_TAB = 'tap_faq_tab',
    TAP_ADD_MORE_DETAILS_CTA = 'tap_add_more_details_cta',
    TAP_ADD_MORE_DETAILS_SUBMIT = 'tap_add_more_details_submit',
    TAP_EDIT_POLICY_HOLDER_DETAILS_CTA = 'tap_edit_policy_holder_details_cta',
    TAP_KNOW_MORE = 'tap_know_more',
    TAP_PDP_FAQ_KNOW_MORE = 'tap_pdp_faq_know_more',
    TAP_PDP_HELP_PAGES_CTA = 'tap_pdp_help_pages_cta',
    TAP_GET_VOUCHER_CTA = 'tap_get_voucher_cta',
    TAP_BTN_REPAIR_REQUEST_PDP_PAGE = 'tap_btn_repair_request_pdp_page',
}

export enum ElectronicsPolicyEditSegments {
    TAP_UPDATE_PRODUCT_ORDER_ID = 'tap_update_product_order_id',
    TAP_UPDATE_SERIAL_NUMBER = 'tap_update_serial_number',
    TAP_UPLOAD_DOCUMENT = 'tap_upload_document',
    TAP_VIEW_SAMPLE_DOCUMENT = 'tap_view_sample_document',
    TAP_EDIT_DETAILS_CONTINUE = 'tap_edit_details_continue',
}

export enum ElectronicsFnolViewEvents {
    VIEW_PAGE_IMEI = 'view_page_imei',
    VIEW_PAGE_IMEI_CONFIRMATION_POPUP = 'view_page_imei_confirmation_popup',
    VIEW_PAGE_MOBILE_DAMAGE_TYPE = 'view_page_mobile_damage_type',
    VIEW_PAGE_PINCODE = 'view_page_pincode',
    VIEW_PAGE_MODE_OF_SETTLEMENT = 'view_page_mode_of_settlement',
    VIEW_PAGE_ADD_SPARE_PHONE = 'view_page_add_spare_phone',
    VIEW_PAGE_PICK_UP_ADDRESS_DETAILS = 'view_page_pick_up_address_details',
    VIEW_PAGE_UPLOAD_PHOTOS = 'view_page_upload_photos',
    VIEW_PAGE_SERVICE_CENTER_DETAILS = 'view_page_service_center_details ',
    VIEW_PAGE_TRANSFER_OPTION = 'view_page_transfer_option',
    VIEW_PAGE_UPI_DETAILS = 'view_page_upi_details',
    VIEW_PAGE_BANK_DETAILS = 'view_page_bank_details',
    VIEW_PAGE_REVIEW_REQUEST_DETAILS = 'view_page_review_request_details ',
    VIEW_PAGE_REQUEST_REGISTERED = 'view_page_request_registered',
    VIEW_PAGE_TRACK_REPAIR_REQUEST = 'view_page_track_repair_request',
    VIEW_PAGE_CONFIRM_CLAIM_WITHDRAW_POPUP = 'view_page_confirm_claim_withdraw_popup',
    VIEW_PAGE_INCIDENT_DETAILS = 'view_page_incident_details',
}

export enum ElectronicsFnolTrackEvents {
    TAP_BTN_BACK = 'tap_btn_back',
    TAP_BTN_IMEI_PAGE = 'tap_btn_imei_page',
    TAP_BTN_IMEI_PAGE_CONFIRMATION_POPUP = 'tap_btn_imei_page_confirmation_popup',
    TAP_BTN_MOBILE_DAMAGE_TYPE = 'tap_btn_mobile_damage_type',
    TAP_BTN_CONTINUE_MOBILE_DAMAGE_TYPE_PAGE = 'tap_btn_continue_mobile_damage_type_page',
    TAP_BTN_INCIDENT_DATE_INCIDENT_DETAIL_PAGE = 'tap_btn_incident_date_incident_detail_page',
    TAP_BTN_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE = 'tap_btn_incident_description_incident_detail_page',
    TAP_INPUT_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE = 'tap_input_incident_description_incident_detail_page',
    TAP_BTN_CONTINUE_INCIDENT_DETAIL_PAGE = 'tap_btn_continue_incident_detail_page',
    TAP_BTN_CONTINUE_PINCODE_PAGE = 'tap_btn_continue_pincode_page',
    TAP_BTN_SELECT_MODE_OF_SETTLEMENT_PAGE = 'tap_btn_select_mode_of_settlement_page',
    TAP_BTN_CONTINUE_PICK_UP_ADDRESS_DETAILS = 'tap_btn_continue_pick_up_address_details',
    TAP_BTN_CONTINUE_UPLOAD_PHOTOS = 'tap_btn_continue_upload_photos',
    TAP_BTN_CONTINUE_SPARE_PHONE = 'tap_btn_continue_spare_phone',
    TAP_BTN_CONTINUE_SERVICE_CENTER_DETAILS = 'tap_btn_continue_service_center_details',
    TAP_BTN_CONTINUE_TRANSFER_PAGE = 'tap_btn_continue_transfer_page ',
    TAP_BTN_ADD_DETAILS_TRANSFER_PAGE = 'tap_btn_add_details_transfer_page',
    TAP_BTN_CONFIRM_UPI_DETAILS = 'tap_btn_confirm_upi_details',
    TAP_BTN_CONTINUE_UPI_DETAILS = 'tap_btn_continue_upi_details',
    TAP_BTN_CONFIRM_BANK_DETAILS = 'tap_btn_confirm_bank_details',
    TAP_BTN_CONTINUE_BANK_DETAILS = 'tap_btn_continue_bank_details',
    TAP_BTN_CONTINUE_REVIEW_REQUEST_DETAILS = 'tap_btn_continue_review_request_details ',
    TAP_BTN_TRACK_REQUEST_REGISTERED = 'tap_btn_track_request_registered',
    TAP_BTN_WITHDRAW_CLAIM_TRACK_REPAIR_REQUEST = 'tap_btn_withdraw_claim_track_repair_request',
    TAP_BTN_WITHDRAW_CLAIM_WITHDRAW_POPUP = 'tap_btn_withdraw_claim_withdraw_popup',
    AVAILABLE_CLAIM_MODES_DURING_MOBILE_FNOL = 'available_claim_modes_during_mobile_fnol',
}

export enum ElectronicsFnolPages {
    IMEI_SCREEN = 'imei_screen',
    MOBILE_DAMAGE_TYPE_SCREEN = 'mobile_damage_type_screen',
    INCIDENT_DETAILS_SCREEN = 'incident_details_screen',
    PINCODE_SCREEN = 'pincode_screen',
    SETTLEMENT_MODE_PAGE = 'settlement_mode_page',
    ADD_SPARE_PHONE_PAGE = 'add_spare_phone_page',
    PICK_UP_ADDRESS_PAGE = 'pick_up_address_page',
    UPLOAD_PHOTO_REIMBURSEMENT_FLOW = 'upload_photo_reimbursement_flow',
    SERVICE_CENTER_DETAILS = 'service_center_details',
    PAYMENT_SCREEN = 'payment_screen',
    REQUEST_DETAILS_SCREEN = 'request_details_screen',
    TRACK_REQUEST_SCREEN = 'track_request_screen',
    WITHDRAW_CLAIM_SCREEN = 'withdraw_claim_screen',
    POLICY_DETAIL_PAGE = 'policy_detail_page',
}

export enum MPosSegmentViewEvents {
    VIEW_LOGIN_CUSTOMER = 'view_pos_login_customer',
    VIEW_CUSTOMER_CONFIRMATION_PAGE = 'view_pos_customer_confirmation_page',
    VIEW_PLAN_DETAILS_PAGE_CUSTOMER = 'view_pos_plan_details_page_customer',
    VIEW_CUSTOMER_SUCCESS_SCREEN = 'view_pos_customer_success_screen',
    VIEW_PAYMENT_SUCCESS_SCREEN = 'view_payment_success_screen',
    VIEW_PAYMENT_FAILURE_SCREEN = 'view_payment_failure_screen',
}

export enum MPosSegementTrackEvents {
    TAP_CTA_VIEW_DETAILS = 'tap_pos_cta_view_details',
    TAP_CTA_TNC_CUSTOMER = 'tap_pos_cta_tnc_customer',
    TAP_BTN_PAY_TO_DEALER = 'tap_pos_btn_pay_to_dealer',
    TAP_BTN_PAY_ONLINE = 'tap_pos_btn_pay_online',
    TAP_BTN_DOWNLOAD_THE_APP = 'tap_pos_btn_download_the_app',
}

export enum MPosSegmentPages {
    CUSTOMER_LOGIN = 'customer_login',
    CUSTOMER_CONFIRMATION = 'customer_confirmation',
    PLAN_DETAILS = 'plan_details',
    CUSTOMER_SUCCESS = 'customer_success',
}

export enum SegmentViewEvents {
    VIEW_PAGE_ONBOARDING_LANDING = 'view_page_onboarding_landing',
    VIEW_PAGE_USER_DETAILS = 'view_page_user_details',
    VIEW_PAGE_LOADER = 'view_page_loader',
    VIEW_PAGE_CAR_REGISTRATION_NUMBER = 'view_page_car_registration_number',
    VIEW_PAGE_VOUCHER = 'view_page_voucher',
    VIEW_BANNER_VOUCHER = 'view_banner_voucher',
}

export enum SegmentTrackEvents {
    TAP_BTN_CONTINUE_LANDING_PAGE = 'tap_btn_continue_landing_page',
    TAP_BTN_CONTINUE_USER_DETAILS_PAGE = 'tap_btn_continue_user_details_page',
    TAP_BTN_CLOSE_MODAL_CAR_NUMBER_MODAL = 'tap_btn_close_modal_car_number_modal',
    TAP_BTN_GET_COUPON_CAR_NUMBER_MODAL = 'tap_btn_get_coupon_car_number_modal',
    TAP_BTN_NO_CAR_CAR_NUMBER_MODAL = 'tap_btn_no_car_car_number_modal',
    TAP_BTN_CLOSE_VOUCHER_MODAL = 'tap_btn_close_voucher_modal',
    TAP_BTN_VIEW_PLAN_VOUCHER_MODAL = 'tap_btn_view_plan_voucher_modal',
    TAP_BTN_REDEEM_VOUCHER_POLICY_DETAIL_PAGE = 'tap_btn_redeem_voucher_policy_detail_page',
}

export enum InternetFnolTrackEvents {
    TAP_BTN_VIEW_DOC_SAMPLE = 'tap_btn_view_doc_sample',
    TAP_BTN_VIEW_DOC_INFO = 'tap_btn_view_doc_info',
    TAP_BTN_UPLOAD_DOCUMENT = 'tap_btn_upload_document',
    UPLOAD_DOCUMENT_SUCCESS = 'upload_document_success',
    UPLOAD_DOCUMENT_TO_JARVIS_INIT = 'upload_document_to_jarvis_init',
    UPLOAD_DOCUMENT_TO_JARVIS_SUCCESS = 'upload_document_to_jarvis_success',
    SEND_JARVIS_EVENT_INIT = 'send_jarvis_event_init',
    SEND_JARVIS_EVENT_SUCCESS = 'send_jarvis_event_success',
    TAP_BTN_ADD_MORE_DOCUMENTS = 'tap_btn_add_more_documents',
    TAP_BTN_DELETE_UPLOADED_DOCUMENTS = 'tap_btn_delete_uploaded_documents',
    TAP_CONTINUE_FROM_DOCUMENT_UPLOAD = 'tap_continue_from_document_upload',
    TAP_BACK_FROM_DOCUMENT_UPLOAD = 'tap_back_from_document_upload',
    TAP_BTN_DOC_PAGE_CONTINUE = 'tap_btn_doc_page_continue',
    TAP_BTN_PAYMENT_MODE_SELECTION = 'tap_btn_payment_mode_selection',
    TAP_BTN_PAYMENT_SCREEN_CONTINUE = 'tap_btn_payment_screen_continue',
    TAP_BTN_ADD_NEW_PAYMENT_DETAILS = 'tap_btn_add_new_payment_details',
    TAP_BTN_EDIT_CLAIM = 'tap_btn_edit_claim',
    TAP_BTN_TRACK_CLAIM = 'tap_btn_track_claim',
    TAP_BTN_DECLARATION = 'tap_btn_declaration',
    TAP_BTN_CLAIM = 'tap_btn_claim',
    TAP_BTN_POLICY_DOCUMENT = 'tap_btn_policy_document',
    TAP_BTN_POLICY_DOCUMENT_DOWNLOAD = 'tap_btn_policy_document_download',
    TAP_BTN_EMAIL_POLICY = 'tap_btn_email_policy',
    TAP_BTN_SMS_POLICY = 'tap_btn_sms_policy',
    SELECT_FIELD_VALUE = 'select_field_value',
    TAP_BTN_GET_DOCUMENT = 'tap_btn_get_document',
    TAP_BTN = 'tap_btn',
}

export enum InternetFnolViewEvents {
    VIEW_UPLOAD_DOCUMENTS = 'view_document_upload_page',
    VIEW_DOCUMENT_UPLOAD_MODAL = 'view_document_upload_modal',
    VIEW_PAYMENT_SCREEN = 'view_internet_fnol_payment_screen',
    VIEW_THANKYOU = 'view_internet_fnol_thank_you',
    VIEW_ERROR_DOC_UPLOAD = 'view_error_doc_upload',
    VIEW_PENNY_DROP_VERIFICATION_ERROR = 'view_penny_drop_verification_error',
    VIEW_POLICY_DISPLAY_PAGE = 'view_policy_display_page',
    VIEW_GET_POLICY_DOCUMENT_MODAL = 'view_get_policy_document_modal',
    VIEW_SMS_POLICY_MODAL = 'view_sms_policy_modal',
    VIEW_EMAIL_POLICY_MODAL = 'view_email_policy_modal',
    VIEW_ADD_DEPENDANT_MODAL = 'view_add_dependant_modal',
    VIEW_PDP_HEALTH_CARD = 'view_pdp_health_card',
    VIEW_SELECT_ONGOING_CLAIMS_PAGE = 'view_select_ongoing_claim_pages',
    VIEW_PRIMARY_COVER_SELECTION_PAGE = 'view_primary_cover_selection_page',
    VIEW_SECONDARY_COVER_SELECTION_PAGE = 'view_secondary_cover_selection_page',
    VIEW_REVIEW_CLAIM_DETAILS_PAGE = 'view_review_claim_details_page',
    VIEW_ADD_NOMINEE_MODAL = 'view_add_nominee_modal',
    VIEW_EDIT_NOMINEE_MODAL = 'view_edit_nominee_modal',
}

export enum InternetFnolPageTypes {
    DOCUMENT_UPLOAD_PAGE = 'document_upload_main_page',
    DOCUMENT_UPLOAD_MODAL = 'document_upload_modal',
    PDP_MAIN_PAGE = 'pdp_main_page',
    PDP_GET_POLICY_DOCUMENT_MODAL = 'pdp_get_policy_document_modal',
    PDP_EMAIL_POLICY_MODAL = 'pdp_email_policy_modal',
    PDP_SMS_POLICY_MODAL = 'pdp_sms_policy_modal',
    PDP_ADD_DEPENDANT_MODAL = 'pdp_add_dependant_modal',
    PDP_ADD_NOMINEE_MODAL = 'pdp_add_nominee_modal',
    PDP_EDIT_NOMINEE_MODAL = 'pdp_edit_nominee_modal',
    PDP_HEALTH_CARD = 'pdp_health_card',
    SELECT_ONGOING_CLAIM = 'select_ongoing_claim',
    PDP_ADD_DEPENDENT_MODAL = 'pdp_add_dependent_modal',
    PDP_TRACK_ONGOING_CLAIMS = 'pdp_track_ongoing_claims',
    COVER_SELECTION_MAIN_PAGE = 'cover_selection_main_page',
    WHO_WAS_AFFECTED_MAIN_PAGE = 'who_was_affected_main_page',
    INSURED_DETAILS_MAIN_PAGE = 'insured_details_main_page',
    INSURED_DETAILS_RELATION_DROPDOWN = 'insured_details_relation_dropdown',
    INSURED_DETAILS_GENDER_DROPDOWN = 'insured_details_gender_dropdown',
    INSURED_DETAILS_CITY_DROPDOWN = 'insured_details_city_dropdown',
    INSURED_DETAILS_DOB_DATEPICKER = 'insured_details_dob_datepicker',
    INCIDENT_DETAILS_MAIN_PAGE = 'incident_details_main_page',
    TRACK_CLAIM_MAIN_PAGE = 'track_claim_main_page',
    REVIEW_MAIN_PAGE = 'review_main_page',
    REVIEW_EDIT_SUMMARY_MODAL = 'review_edit_summary_modal',
    SELECT_PAYEE_MAIN_PAGE = 'select_payee_main_page',
}

export enum InternetFnolPages {
    DOCUMENT_UPLOAD = 'document_upload',
    POLICY_DISPLAY_PAGE = 'policy_display_page',
    ONGOING_CLAIMS_PAGE = 'ongoing_claims_page',
    PRIMARY_COVER_SELECTION = 'primary_cover_selection',
    SECONDARY_COVER_SELECTION = 'secondary_cover_selection',
    WHO_WAS_AFFECTED = 'who_was_affected',
    INSURED_DETAILS = 'insured_details',
    INCIDENT_DETAILS = 'incident_details',
    TRACK_CLAIM = 'track_claim',
    REVIEW_CLAIM_DETAILS = 'review_claim_details',
    SELECT_WHOM_YOU_WANT_TO_PAY = 'select_whom_you_want_to_pay',
}

export enum InternetFnolButton {
    ADD_MORE_DOCUMENTS = 'add_more_documents',
    UPLOAD_DOCUMENT = 'upload_document',
    DELETE_UPLOADED_DOCUMENT = 'delete_uploaded_document',
    CONTINUE_FROM_DOCUMENT_UPLOAD = 'continue_from_document_upload',
    BACK_FROM_DOCUMENT_UPLOAD = 'back_from_document_upload',
    VIEW_DOC_SAMPLE = 'view_doc_sample',
    BUTTON_INFO = 'button_info',
    CLAIM = 'claim',
    POLICY_DOCUMENT = 'policy_document',
    DOWNLOAD_POLICY_DOCUMENT = 'download_policy_document',
    EMAIL_POLICY_DOCUMENT = 'email_policy_document',
    SMS_POLICY_DOCUMENT = 'sms_policy_document',
    ENTER_PHONE_NUMBER = 'enter_phone_number',
    ENTER_EMAIL_ID = 'enter_email_id',
    GET_DOCUMENT = 'get_document',
    HEALTH_CARD = 'health_card',
    TELECONSULTATION_INSTALL = 'teleconsultation_install',
    ADD_DEPENDANT = 'add_dependant',
    EDIT_NOMINEE = 'edit_nominee',
    ENTER_NAME = 'enter_name',
    ENTER_DOB = 'enter_dob',
    ENTER_RELATION = 'enter_relation',
    CONTINUE = 'continue',
    CROSS_SELL = 'cross_sell',
    BACK_FROM_POLICY_DOCUMENT = 'back_from_policy_document',
    BACK_FROM_EMAIL_POLICY_MODAL = 'back_from_email_policy_modal',
    BACK_FROM_SMS_POLICY_MODAL = 'back_from_sms_policy_modal',
    BACK_FROM_ADD_DEPENDENT_MODAL = 'back_from_add_dependent_modal',
    SELECT_ONGOING_CLAIM = 'select_ongoing_claim',
    TRACK_ONGOING_CLAIMS = 'track_ongoing_claims',
    BACK_FROM_SECONDARY_COVER_SELECTION = 'back_from_secondary_cover_selection',
    BACK_FROM_PRIMARY_COVER_SELECTION = 'back_from_primary_cover_selection',
    BACK_FROM_WHO_WAS_AFFECTED = 'back_from_who_was_affected',
    ENTER_GENDER = 'enter_gender',
    ENTER_CITY = 'enter_city',
    CONTINUE_FROM_INSURED_SELECTION = 'continue_from_insured_selection',
    CONTINUE_FROM_INCIDENT_DETAILS = 'continue_from_incident_details',
    BACK_FROM_INCIDENT_DETAILS = 'back_from_incident_details',
    TRACK_REQUEST = 'track_request',
    SUBMIT_REVIEW_CLAIM_DETAILS = 'submit_review_claim_details',
    BACK_FROM_REVIEW_CLAIM_DETAILS = 'back_from_review_claim_details',
    TOGGLE_WHATSAPP_UPDATES = 'toggle_whatsapp_updates',
    TOGGLE_DECLARATION_CONSENT = 'toggle_declaration_consent',
    OPEN_EDIT_SUMMARY_MODAL = 'open_edit_summary_modal',
    SELECT_PAYEE = 'select_payee',
    BACK_FROM_SELECT_PAYEE = 'back_from_select_payee',
    SELECT_GUARDIAN = 'select_guardian',
    SUBMIT_FROM_SELECT_PAYEE = 'submit_from_select_payee',
}

export enum EWFnolViewEvents {
    VIEW_PAGE_PINCODE = 'view_page_pincode',
    VIEW_PAGE_POPUP_PINCODE = 'view_page_popup_pincode',
    VIEW_PAGE_LOSS_INFORMATION = 'view_page_loss_information',
    VIEW_PAGE_INCIDENT_DATE_INFORMATION = 'view_page_address_information',
    VIEW_PAGE_ADDRESS_INFORMATION = 'view_page_address_details',
    VIEW_PAGE_ADD_ADDRESS = 'view_page_add_address',
    VIEW_PAGE_PREFERRED_VISIT_DATE = 'view_page_preferred_visit_date',
    VIEW_PAGE_REQUEST_SUMMARY = 'view_page_request_summary',
    VIEW_PAGE_REQUEST_REGISTERED = 'view_page_request_registered',
    VIEW_PAGE_TRACK_REPAIR_REQUEST = 'view_page_track_repair_request',
    VIEW_PAGE_CONFIRM_CLAIM_WITHDRAW_POPUP = 'view_page_confirm_claim_withdraw_popup',
    VIEW_PAGE_REQUEST_CREATED = 'view_page_request_created',
}

export enum EWFnolTrackEvents {
    TAP_BTN_BACK = 'tap_btn_back',
    TAP_BTN_DAMAGE_TYPE = 'tap_btn_mobile_damage_type',
    TAP_BTN_CONTINUE_LOSS_INFORMATION = 'tap_btn_continue_loss_information',
    TAP_BTN_INCIDENT_CONTINUE_INCIDENT_DATE_INFORMATION = 'tap_btn_continue_incident_date_information',
    TAP_BTN_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE = 'tap_btn_incident_description_incident_detail_page',
    TAP_INPUT_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE = 'tap_input_incident_description_incident_detail_page',
    TAP_BTN_CONTINUE_INCIDENT_DETAIL_PAGE = 'tap_btn_continue_incident_detail_page',
    TAP_BTN_CONTINUE_POP_UP_PINCODE = 'tap_btn_continue_pop_up_pincode',
    TAP_BTN_CONTINUE_REVIEW_REQUEST_DETAILS = 'tap_btn_continue_review_request_details ',
    TAP_BTN_TRACK_REQUEST = 'tap_btn_track_request',
    TAP_BTN_WITHDRAW_CLAIM_TRACK_REPAIR_REQUEST = 'tap_btn_withdraw_claim_track_repair_request',
    TAP_BTN_WITHDRAW_CLAIM_WITHDRAW_POPUP = 'tap_btn_withdraw_claim_withdraw_popup',
    TAP_BTN_SELECT_ADDRESS = 'tap_btn_select_address',
    TAP_BTN_ADD_ADDRESS = 'tap_btn_add_address',
    TAP_BTN_SAVE_ADD_ADDRESS = 'tap_btn_save_add_address',
    TAP_BTN_SUBMIT_PREFERRED_VISIT_DATE = 'tap_btn_submit_preferred_visit_date',
    TAP_BTN_SUBMIT_REQUEST_SUMMARY = 'tap_btn_submit_request_summary',
}

export enum EWFnolPages {
    POLICY_DETAIL_PAGE = 'policy_detail_page',
    PINCODE_SCREEN = 'pincode_screen',
    PINCODE_POP_UP = 'pincode_pop_up',
    DAMAGE_SCREEN = 'damage_screen',
    INCIDENT_INFORMATION = 'incident information',
    ADDRESS_INFORMATION = 'address_information',
    ADD_ADDRESS_SCREEN = 'add_address_screen',
    SCHEDULE_VISIT_SCREEN = 'schedule_visit_screen',
    REVIEW_SUMMARY = 'review_summary',
    REQUEST_CREATED = 'request_created',
    TRACK_REQUEST_SCREEN = 'track_request_screen',
    WITHDRAW_CLAIM_SCREEN = 'withdraw_claim_screen',
}
